import React, { Component } from 'react';
import Link from '../utils/link';
import { Phone } from './icons';
import Logo from './logo';

class Header extends Component {
  state = {
    offCanvas: false,
    activeDropdown: null,
    activeOffCanvasPanel: null,
  };

  _hideOffCanvas = () => {
    this.setState({ offCanvas: false });
  };

  _hideAll = () => {
    this.setState({
      offCanvas: false,
      activeDropdown: null,
      activeOffCanvasPanel: null,
    });
  };

  _toggleOffCanvas = () => {
    this.setState((prevState) => ({
      offCanvas: !prevState.offCanvas,
      activeOffCanvasPanel: null,
    }));
  };

  render() {
    const { offCanvas, activeDropdown, activeOffCanvasPanel } = this.state;
    const { data } = this.props;

    let props = {
      onClick: this._hideOffCanvas,
      activeClassName: 'active',
    };
    let dropProps = {
      onClick: this._hideAll,
      activeClassName: 'active',
    };

    let headerClass = 'header';
    if (activeDropdown) headerClass += ' header--dropdown';
    if (activeOffCanvasPanel) headerClass += ' header--off-canvas-panel';
    if (offCanvas) headerClass += ' header--off-canvas';
    if (this.props.pageContext.header) headerClass += ` header--${this.props.pageContext.header}`;

    return (
      <>
        <header className={headerClass}>
          <div className='header__inner'>
            <Link to='/' title='Bull' className='header__logo' {...props}>
              <Logo />
            </Link>
            <nav className='header__nav'>
              <ul>
                {data.wp.siteOptions.acf.headerMenu.map((item, index) => (
                  <li
                    key={index}
                    className={activeDropdown === index ? 'active' : ''}
                    onMouseEnter={() => this.setState({ activeDropdown: index })}
                    onMouseLeave={() => this.setState({ activeDropdown: null })}
                  >
                    <Link to={item.link.url} {...props}>
                      {item.link.title}
                    </Link>
                    {item.subMenu && (
                      <div className='header__dropdown'>
                        <ul>
                          {item.subMenu.map((subItem, subIndex) => (
                            <li key={subIndex}>
                              <Link to={subItem.link.url} {...dropProps}>
                                {subItem.link.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
            <div className='header__button'>
              {/* <Link to='tel:1800513894' className='btn btn--forest'>
                <Phone />
                <span>1800 513 894</span>
              </Link> */}
              <button
                onClick={this._toggleOffCanvas}
                className={offCanvas ? 'header__hamburger active' : 'header__hamburger'}
              >
                <span className='lines'></span>
              </button>
            </div>
          </div>
        </header>
        <div className={`off-canvas ${offCanvas && 'off-canvas--active'}`}>
          <div className='off-canvas__inner'>
            <nav className='off-canvas__nav'>
              <ul>
                {data.wp.siteOptions.acf.headerMenu.map((item, index) => (
                  <li
                    key={index}
                    onClick={
                      item.subMenu?.length > 0
                        ? () => this.setState({ activeOffCanvasPanel: index })
                        : undefined
                    }
                  >
                    {item.subMenu?.length > 0 ? (
                      item.link.title
                    ) : (
                      <Link to={item.link.url} {...props}>{item.link.title}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
            <div className='off-canvas__contact'>
              <p>
                <Link to='mailto:hello@bullinvest.com.au'>hello@bullinvest.com.au</Link>
              </p>
            </div>
          </div>
          {data.wp.siteOptions.acf.headerMenu.map((item, index) => (
            <div
              key={index}
              className={`off-canvas__panel${activeOffCanvasPanel === index ? ' active' : ''}`}
            >
              <ul>
                <li onClick={() => this.setState({ activeOffCanvasPanel: null })}>Back To Main</li>
                {item.link.url &&
                  item.subMenu?.map((subItem, subIndex) => (
                    <li key={subIndex}>
                      <Link to={subItem.link.url} {...dropProps}>
                        {subItem.link.title}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </div>
      </>
    );
  }
}

export default Header;